import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-zcams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-zcams.component.scss?ngResource";
import { ChangeDetectorRef, Component } from '@angular/core';
import { AppControllerService } from 'src/app/app-controller.service';
import { AflaModuleStrategyService } from 'src/app/shared/services/afla-module-strategy/afla-module-strategy.service';
import { SelectedApplicationService } from 'src/app/shared/services/selected-application/selected-application.service';
import { ApplicationViewService } from 'src/app/view-application/shared/application-view.service';
import { ViewApplicationBaseComponent } from 'src/app/view-application/shared/view-application-base/view-application-base.component';
import { ViewApplicationDetailsZcConstants } from './view-application-details-zc.constant';
import { RouterParamsService } from 'src/app/shared/services/route-params.service';
let ViewApplicationDetailsZcamsComponent = class ViewApplicationDetailsZcamsComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    changeDetectorRefs;
    routerParamsService;
    applicationTypeCtrl = ViewApplicationDetailsZcConstants.TYPE_CTRL;
    applicationTypeLbl = ViewApplicationDetailsZcConstants.TYPE_LBL;
    descriptionCtrl = ViewApplicationDetailsZcConstants.DESCRIPTION_CTRL;
    descriptionLbl = ViewApplicationDetailsZcConstants.DESCRIPTION_LBL;
    applicationTypePlaceHolder = ViewApplicationDetailsZcConstants.APPLICATION_PLACE_HOLDER;
    applicationTypes = [];
    detailsForm;
    title = "";
    selectedApplicationDmSubscription;
    getLookupsObservableSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appController, changeDetectorRefs, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
        this.getMetadata();
    }
    ngOnInit() {
        this.loadLookup();
        this.initForm();
        this.getMetadata();
        this.populateForm(this.selectedApplication);
        this.subscribeToSelectedApplication();
    }
    handleRouteChange() {
    }
    loadMetadata(stepMeta) {
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationDmSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.populateForm(application);
            }
        });
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm.enable();
    }
    populateForm(application) {
        if (application && application.appId > 0)
            this.detailsForm.markAsTouched();
        else
            return;
        this.detailsForm.get(this.applicationTypeCtrl).setValue(application.type);
        this.detailsForm.get(this.descriptionCtrl).setValue(application.description);
    }
    loadLookup() {
        this.getLookupsObservableSubscription = this.applicationViewService.getLookupsObservable({ $filter: `moduleId eq ${this.appController.selectedModuleID} and name eq 'ApplicationType' and deleted eq false` }).subscribe(lookupValues => {
            const lookup = lookupValues.value;
            lookup.forEach(lp => {
                this.applicationTypes.push(JSON.parse(lp.content));
            });
            this.changeDetectorRefs.detectChanges();
        });
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
};
ViewApplicationDetailsZcamsComponent = __decorate([
    Component({
        selector: 'app-view-application-details-zcams',
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsZcamsComponent);
export { ViewApplicationDetailsZcamsComponent };
